import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Chapter from "./Chapter";

export default function Services() {
  const { content, t, ui } = useSite();

  return (
    <section id="services" className="mx-auto max-w-7xl scroll-mt-28 px-6 py-24" data-testid="services-section">
      <Chapter num="01" title={ui.ourServices} sub={ui.servicesSub} testId="services-chapter" />
      <div className="grid gap-4 md:grid-cols-3">
        {content.services.map((s, i) => (
          <motion.article
            key={s.id}
            data-testid={`service-card-${s.id}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden rounded-2xl border border-navy-border bg-navy-surface transition-colors hover:border-volt/50 ${
              i === 0 || i === 3 ? "md:col-span-2" : ""
            }`}
          >
            <div className="relative h-52 overflow-hidden sm:h-60">
              <img
                src={s.image}
                alt={t(s.title)}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-surface via-navy-surface/20 to-transparent" />
              <span className="absolute left-4 top-4 rounded-md bg-navy/80 px-2.5 py-1 font-mono text-xs font-semibold tracking-widest text-volt backdrop-blur">
                0{i + 1}
              </span>
            </div>
            <div className="flex items-start justify-between gap-4 p-6">
              <div>
                <h3 className="font-display text-2xl uppercase tracking-wide text-white transition-colors group-hover:text-volt">
                  {t(s.title)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{t(s.desc)}</p>
              </div>
              <ArrowUpRight
                size={22}
                className="mt-1 shrink-0 text-slate-600 transition-all group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-volt"
              />
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
